import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService, NavigationService, ProviderService } from '@app/core/services';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { combineLatest, EMPTY } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

@Component({
  template: '',
})
export class ResolveHomeComponent implements OnInit, OnDestroy {
  constructor(
    private authService: AuthService,
    private navService: NavigationService,
    private providerService: ProviderService
  ) {}

  ngOnInit(): void {
    if (!this.authService.authenticated) {
      this.navService.navigateByUrl('/auth/login');
      return;
    }

    this.authService.currentTenantId$
      .pipe(
        take(1),
        switchMap(tenantId => {
          if (!tenantId) {
            this.navService.navigate(['error']);
            return EMPTY;
          }

          return combineLatest([this.providerService.isHbcGoUser$, this.authService.superAdmin$]).pipe(
            take(1),
            switchMap(([isHbcGoUser, superAdmin]) => {
              if (isHbcGoUser) {
                // Super admins managing a Go practice land on provider settings
                const destination = superAdmin ? [tenantId, 'provider', 'edit'] : [tenantId, 'hbc-go'];
                this.navService.navigate(destination);
              } else {
                this.navService.navigate([tenantId, 'home']);
              }

              return EMPTY;
            })
          );
        }),
        untilDestroyed(this)
      )
      .subscribe();
  }

  ngOnDestroy(): void {}
}
